import { render, staticRenderFns } from "./ApprendoBtn.vue?vue&type=template&id=08a3474e&scoped=true"
import script from "./ApprendoBtn.vue?vue&type=script&lang=js"
export * from "./ApprendoBtn.vue?vue&type=script&lang=js"
import style0 from "./ApprendoBtn.vue?vue&type=style&index=0&id=08a3474e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a3474e",
  null
  
)

export default component.exports